export default __webpack_public_path__ + "static/media/mater.44fc923c.svg";